import { NetworkService } from './network-service';

const API_BASE_URL = process.env.REACT_APP_API_EXECUTION_ADDRESS;

export default class ClipService {
    static async createClipAsync(formData, queryParams) {
        return await NetworkService.postMultiPartAsync(`${API_BASE_URL}/clip`, formData, queryParams);
    }

    static async deleteClipAsync(id) {
        return await NetworkService.deleteAsync(`${API_BASE_URL}/clip/${id}`);
    }

    static async downloadClipAsync(id) {
        return await NetworkService.getBlobAsync(`${API_BASE_URL}/clip/${id}/download`);
    }
}
